import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {DynamicDataFilterComponent} from './dynamic-data-filter.component';
import {DatePickerModule} from '@syncfusion/ej2-angular-calendars';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslatePipeModule,
        FormsModule,
        DatePickerModule,
        ReactiveFormsModule
    ],
    declarations: [DynamicDataFilterComponent],
    providers: [],
    exports: [DynamicDataFilterComponent]
})

export class DynamicDataFilterModule {

}
